/**
 * Mentees list loading. One request: GET /mentor/engagements returns each
 * card's overview summary (sof_draft_count, next_action), so opening Mentees
 * never fans out one /overview call per engagement. The workspace overview is
 * fetched only when an engagement is opened (MentorEngagementDetailScreen).
 */
import type { EngagementSummary, NextActionKey } from '@/types/mentorEngagements';

export const LIST_TIMEOUT_MS = 20_000;

export function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('timeout')), ms);
    promise.then(
      (value) => { clearTimeout(timer); resolve(value); },
      (error) => { clearTimeout(timer); reject(error); },
    );
  });
}

export interface EngagementListSource {
  list(): Promise<EngagementSummary[]>;
}

/** The whole Mentees page in one bounded request. */
export function loadEngagementList(api: EngagementListSource, timeoutMs = LIST_TIMEOUT_MS): Promise<EngagementSummary[]> {
  return withTimeout(api.list(), timeoutMs);
}

/** The card's "next step" line; null falls back to the generic status text. */
export function cardNextActionKey(row: EngagementSummary): NextActionKey | null {
  return row.next_action?.key ?? null;
}
